import Dialog from "@material-ui/core/Dialog";
import { useTheme } from "@material-ui/core/styles";
import DialogContent from "@material-ui/core/DialogContent";
import FrameRightClick from "./components/FrameRightClick";
import SashRightClick from "./components/SashRightClick";
import MullionRightClick from "./components/MullionRightClick";
import CoupleRightClick from "./components/CoupleRightClick";
import React, { useState } from "react";
import { read } from "Helpers/LocalStorage";
import DrawerService from "Services/http/endpoints/design/DrawerService";
import StatusHandler from "Helpers/StatusHandler";
import showNotify from "Helpers/Notify";
import PartsRightClick from "./components/PartsRightClick";
import { DialogActions } from "@material-ui/core";
import MuiButton from "Components/MuiButton/MuiButton";
import Translator from "Languages/Utility/Translator";
import Grid from "@material-ui/core/Grid";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

function RightClickDialog({
  handleDialog,
  openDialog,
  data,
  sendRightClickData,
}) {
  const { t } = useTranslation();
  const { direction } = useTheme();
  const [changeData, setChangeData] = useState(null);
  const [loading, setLoading] = useState(false);
  const { selectedProject } = useSelector((state) => ({
    selectedProject: state.project.selectedProject,
  }));

  const onEnter = () => {};
  const moveHandlePlace = async () => {
    setLoading(true);
    const params = {
      KeyGroup: read("groupKey"),
      KeyUser: read("userKey"),
      IdProject: selectedProject.Id,
    };
    const response = await DrawerService.getSettingUnit(params);
    let err = StatusHandler(response);
    if (!err.isFail) {
      const settings = response.data.Value;
      const newData = {
        ...data,
        handleValue: settings.Handle,
        nodePointHandle: data?.HandlePop.nodePoint,
        isNegative: data?.HandlePop.isNegative,
      };
      sendRightClickData(newData);
      handleDialog();
    }
    setLoading(false);
  };
  const onFinish = async () => {
    let newData = { ...data };
    if (data.Id_frame) {
      try {
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Id: changeData.frame.value.value,
        };
        const response = await DrawerService.getFrameRightClick(params);
        let err = StatusHandler(response);

        if (!err.isFail) {
          showNotify({
            text: t("mission_accomplished"),
            customClass: "success",
          });
          const list = response.data.Value;
          newData = {
            ...newData,
            Id_frame: changeData.frame.value.value,
            Id_frame_old: data.Id_frame,
            Size_frame: list.Size,
            Is_rebuild_frame: list.IsRebuild,
          };
        }
      } catch (err) {
      console.error('[catch error]', err)
    }
    }
    if (data.Id_sash) {
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Id: changeData.sash.value.value,
      };
      try {
        const response = await DrawerService.getSashRightClick(params);
        let err = StatusHandler(response);
        if (!err.isFail) {
          showNotify({
            text: t("mission_accomplished"),
            customClass: "success",
          });
          const list = response.data.Value;
          newData = {
            ...newData,
            Id_sash: changeData.sash.value.value,
            Size_sash: list.Size,
            Is_cover_glazing: list.IsCover,
          };
        }
      } catch (err) {
      console.error('[catch error]', err)
    }
    }
    if (data.Id_mulion) {
      try {
        const params = {
          KeyGroup: read("groupKey"),
          keyUser: read("userKey"),
          Id: changeData.mullion.value.value,
        };
        const response = await DrawerService.getSizeProfile(params);
        let err = StatusHandler(response);
        if (!err.isFail) {
          showNotify({
            text: t("mission_accomplished"),
            customClass: "success",
          });
          const list = response.data.Value;
          newData = {
            ...newData,
            Id_mulion: changeData.mullion.value.value,
            Size_mulion: list,
          };
        }
      } catch (err) {
      console.error('[catch error]', err)
    }
    }
    if (data.Id_couple) {
      try {
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Id: changeData.couple.value.value,
        };
        const response = await DrawerService.getSizeProfile(params);
        let err = StatusHandler(response);
        if (!err.isFail) {
          showNotify({
            text: t("mission_accomplished"),
            customClass: "success",
          });
          const list = response.data.Value;
          newData = {
            ...newData,
            Id_couple: changeData.couple.value.value,
            width_node: list,
          };
        }
      } catch (err) {
      console.error('[catch error]', err)
    }
    }
    if (data.Id_panel) {
      try {
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Id: changeData.panel.value.value,
        };
        const response = await DrawerService.getSizeProfile(params);
        let err = StatusHandler(response);
        if (!err.isFail) {
          showNotify({
            text: t("mission_accomplished"),
            customClass: "success",
          });
          const value = response.data.Value;
          newData = {
            ...newData,
            Id_panel: changeData.panel.value.value,
            Size_panel: value,
            Is_three: true,
          };
        }
      } catch (err) {
      console.error('[catch error]', err)
    }
    }
    if (data.Id_glazing) {
      try {
        newData = {
          ...newData,
          Id_glazing: changeData.glazing.value.value,
        };
      } catch (err) {
      console.error('[catch error]', err)
    }
    }
    if (data.Id_glass) {
      try {
        newData = {
          ...newData,
          Id_glass: changeData.glassName.value.value,
          Is_three: true,
          patGlass: changeData.glassName.value.NamePattern,
        };
      } catch (err) {
      console.error('[catch error]', err)
    }
    }
    if (
      data?.Id_brand_fitting !== 0 &&
      data?.Id_type_pop_fitting !== 0 &&
      changeData.brand.value.value &&
      changeData.pop.value.value
    ) {
      try {
        newData = {
          ...newData,
          Id_brand_fitting: changeData.brand.value.value,
          Id_type_pop_fitting: changeData.pop.value.value,
        };
      } catch (err) {
      console.error('[catch error]', err)
    }
    }
    if (data.Id_net) {
      try {
        newData = {
          ...newData,
          Id_net: changeData.net.value.value,
        };
      } catch (err) {
      console.error('[catch error]', err)
    }
    }
    sendRightClickData(newData);
    setChangeData(null);
    handleDialog();
  };

  const completePanel = () => {
    const newData = {
      ...data,
      Id_panel: changeData.panel.value
        ? changeData.panel.value.value
        : data.Id_panel,
      Is_sort_panel: true,
      Is_three: true,
    };
    sendRightClickData(newData);
    setChangeData(null);
    handleDialog();
  };

  const onChangeData = (changes) => {
    setChangeData(changes);
  };

  return (
    <Dialog
      dir={direction}
      open={openDialog}
      onClose={handleDialog}
      onEnter={onEnter}
      fullWidth
      maxWidth="sm"
    >
      <div className="dialogHeader">
        <p>
          {data?.Id_frame !== 0 && t("frame")}
          {data?.Id_sash !== 0 && t("sash")}
          {data?.Id_mulion !== 0 && t("isMullion")}
          {data?.Id_couple !== 0 && t("couple")}
          {(data?.Id_panel !== 0 ||
            data?.Id_glazing !== 0 ||
            data?.Id_glass !== 0 ||
            data?.Id_net !== 0 ||
            (data?.Id_brand_fitting !== 0 &&
              data?.Id_type_pop_fitting !== 0)) &&
            t("parts")}
        </p>
      </div>
      <DialogContent style={{ overflow: "visible" }}>
        <Grid container spacing={2}>
          {data?.Id_frame !== 0 && (
            <FrameRightClick data={data} onChangeData={onChangeData} />
          )}
          {data?.Id_sash !== 0 && (
            <SashRightClick data={data} onChangeData={onChangeData} />
          )}
          {data?.Id_mulion !== 0 && (
            <MullionRightClick data={data} onChangeData={onChangeData} />
          )}
          {data?.Id_couple !== 0 && (
            <CoupleRightClick data={data} onChangeData={onChangeData} />
          )}
          {(data?.Id_panel !== 0 ||
            data?.Id_glazing !== 0 ||
            data?.Id_glass !== 0 ||
            data?.Id_net !== 0 ||
            (data?.Id_brand_fitting !== 0 &&
              data?.Id_type_pop_fitting !== 0)) && (
            <PartsRightClick
              data={data}
              onChangeData={onChangeData}
              completePanel={completePanel}
            />
          )}
        </Grid>
        {data?.HandlePop && data?.HandlePop.nodePoint !== "0,0" && (
          <Grid xs={12} className="mt-4 d-flex flex-row justify-content-end">
            <MuiButton
              color="secondary"
              onClick={moveHandlePlace}
              title={<Translator id="moveHandlePlace" />}
              loading={loading}
            />
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <MuiButton
          color="primary"
          onClick={onFinish}
          title={<Translator id="button_save" />}
          disabled={loading}
        />
        <MuiButton onClick={handleDialog} title={<Translator id="enseraf" />} />
      </DialogActions>
    </Dialog>
  );
}

export default RightClickDialog;
